import { SearchContainer } from "@/components/search/SearchContainer";
import { Route } from "/app/src/routes/{-$locale}/search.tsx";
function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <SearchContainer contextId="search" initialSearch={search} onSearchChange={s => {
    navigate({
      search: s,
      resetScroll: false
    });
  }} />;
}
export { RouteComponent as component };